import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Router keeps scroll position across route changes by default, which lands
// deck pages mid-deck when arriving from a scrolled home page.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
